import { defineStore } from "pinia";
import axios from "axios";
import { useLoadingStore } from "@/stores/loadingStore";

export const usePackageStore = defineStore("packageStore", {
  state: () => ({
    packages: [],
    extraFeatures: [],
    isLoading: false,
    error: null,
  }),

  actions: {
    async fetchPackages() {
      const loadingStore = useLoadingStore();
      loadingStore.startLoading();
      this.isLoading = true;
      this.error = null;
      try {
        const response = await axios.get("/api/Package/GetAllPackages");
        this.packages = response.data.Payload;
      } catch (error) {
        this.error = "Paketler alınırken bir hata oluştu";
      } finally {
        loadingStore.finishLoading();
        this.isLoading = false;
      }
    },

    async fetchExtraFeatures() {
      const loadingStore = useLoadingStore();
      loadingStore.startLoading();
      this.isLoading = true;
      this.error = null;
      try {
        const response = await axios.get("/api/Package/GetAllExtraFeatures");
        this.extraFeatures = response.data.Payload;
      } catch (error) {
        this.error = "Ekstra özellikler alınırken bir hata oluştu";
      } finally {
        loadingStore.finishLoading();
        this.isLoading = false;
      }
    },
  },
});
